var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "invoices",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_59",
    transform: "translate(-671.602 -666.464)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1706",
    d: "M700.987 676.464h-16.77a1.617 1.617 0 0 0-1.615 1.615v22.281a1.617 1.617 0 0 0 1.615 1.615h13.908a.562.562 0 0 0 .4-.165l3.915-3.915a.562.562 0 0 0 .165-.4v-19.416a1.617 1.617 0 0 0-1.618-1.615zm-2.3 23.591v-1.505a.491.491 0 0 1 .491-.491h1.5zm-14.47-22.466h16.77a.491.491 0 0 1 .491.49v1.738h-17.752v-1.738a.491.491 0 0 1 .491-.491zm-.49 22.771v-19.419h17.751v15.994h-2.3a1.617 1.617 0 0 0-1.615 1.615v2.3h-13.346a.491.491 0 0 1-.491-.491z",
    className: "cls-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1707",
    d: "M719.979 729.742h-10.717a.562.562 0 0 0 0 1.124h10.717a.562.562 0 0 0 0-1.124z",
    className: "cls-3",
    transform: "translate(-21.95 -44.809)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1708",
    d: "M719.979 752.826h-10.717a.562.562 0 0 0 0 1.124h10.717a.562.562 0 0 0 0-1.124z",
    className: "cls-3",
    transform: "translate(-21.95 -64.224)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1709",
    d: "M716.392 777.472a.562.562 0 0 0-.562-.562h-6.567a.562.562 0 0 0 0 1.124h6.567a.562.562 0 0 0 .562-.562z",
    className: "cls-3",
    transform: "translate(-21.95 -84.479)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoices);
export default __webpack_public_path__ + "static/media/invoices.b2c1b3ea.svg";
export { ForwardRef as ReactComponent };